import { InMemoryCache, type InMemoryCacheConfig } from '@apollo/client/core';
import schemaPossibleTypes from '@seek/ca-graphql-schema/possible-types.json';

export const createCache = ({
  possibleTypes: configPossibleTypes = {},
  ...restCacheOptions
}: InMemoryCacheConfig = {}): InMemoryCache =>
  new InMemoryCache({
    possibleTypes: { ...schemaPossibleTypes, ...configPossibleTypes },
    ...restCacheOptions,
  });

export default (cacheOptions: InMemoryCacheConfig = {}) =>
  createCache(cacheOptions);
